import * as R from 'ramda';

export default function SystemNotificationsDirectiveController(
  $window,
  $scope,
  $timeout,
  userService,
  orgDataService,
  authorizationService
) {
  const vm = this;

  vm.handleDismissNotification = _handleDismissNotification;
  vm.handleNotificationClick = _handleNotificationClick;

  _initEventListeners();

  _activate();

  function _activate() {
    if (authorizationService.getToken()) {
      _refreshNotifications();
    }
  }

  function _refreshNotifications() {
    userService.getSystemNotificationItems().then((notifications) => {
      vm.notifications = notifications;
    });
  }

  function _clearNotifications() {
    vm.notifications = null;
  }

  function _initEventListeners() {
    $scope.$on('loggedIn', _refreshNotifications);
    $scope.$on('loggedOut', _clearNotifications);
  }

  function _handleNotificationClick(notification) {
    if (notification.linkOrScript) {
      $window.open(notification.linkOrScript, '_blank');
    }
  }

  function _handleDismissNotification(notification) {
    orgDataService.dismissSystemNotification(
      notification.systemNotificationId
    ).then(() => {
      notification.isHidden = true;
      $timeout(
        () => {
          vm.notifications = R.reject(
            R.equals(notification),
            vm.notifications
          );
        },
        300
      );
    });
  }
}

SystemNotificationsDirectiveController.$inject = [
  '$window',
  '$scope',
  '$timeout',

  'userService',
  'orgDataService',
  'authorizationService',
];
